// Lib
import React from 'react';

// Hooks
import { useElementTiptapContent } from '../../../../common/tiptap/conversion/elementConversion/useElementTiptapContent';

// Components
import { CommentTiptapEditor, CommentTiptapEditorProps } from './CommentTiptapEditor';

// Types
import { DocumentType } from '../../../../common/tiptap/conversion/elementConversion/elementConversion';
import { ImEditorContent } from '../../../../common/elements/elementModelTypes';

// Styles
import './CommentEditor.scss';

type CommentEditorProps = Omit<CommentTiptapEditorProps, 'tiptapContent' | 'isEditing' | 'isEditable'> & {
    textContent: ImEditorContent | string;
    isEditing?: boolean;
    isEditable?: boolean;
};

const CommentEditor = (props: CommentEditorProps) => {
    const {
        commentId,
        parentThreadElementId,
        textContent,
        isUpdating,
        isEditing,
        isEditable,
        isSingleSelected,
        spellCheck,
        hidePostButton,
        placeholder,
        editorId,
        editorKey,
        currentEditorKey,
        currentEditorId,
        onActivity,
        saveContent,
        onSubmit,
        onBlur,
        onEmptyBackspace,
        startEditing,
        editorInstanceRef,
    } = props;

    const tiptapContent = useElementTiptapContent(textContent, commentId, DocumentType.textContent);

    return (
        <CommentTiptapEditor
            commentId={commentId}
            tiptapContent={tiptapContent}
            parentThreadElementId={parentThreadElementId}
            isUpdating={isUpdating}
            isEditing={!!isEditing}
            isEditable={!!isEditable}
            isSingleSelected={isSingleSelected}
            spellCheck={spellCheck}
            hidePostButton={hidePostButton}
            placeholder={placeholder}
            editorId={editorId}
            editorKey={editorKey}
            currentEditorKey={currentEditorKey}
            currentEditorId={currentEditorId}
            onActivity={onActivity}
            saveContent={saveContent}
            onSubmit={onSubmit}
            onEmptyBackspace={onEmptyBackspace}
            onBlur={onBlur}
            startEditing={startEditing}
            editorInstanceRef={editorInstanceRef}
        />
    );
};

export default CommentEditor;
